export enum ImageAspectRatio {
  SIZE_16x9 = '16:9',
  SIZE_5x2 = '5:2',
  SIZE_3x1 = '3:1',
  SIZE_2X1 = '2:1',
}

export enum DOC_DIR {
  LTR = 'ltr',
  RTL = 'rtl',
}
